module.exports = __webpack_public_path__ + "static/media/slidee-4.ccaf0292.jpg";